import { Scene, OrthographicCamera } from "three";
import { config, getPhrasesInPercent } from "./config";
import MaskLines from "./MaskLines.js";
import { smoothstep } from "~/lib/utils.js";

export default class Mask {
    constructor() {
        this.scene = new Scene();

        this._reverse = config.mask.reverse;
        this.progress = this._reverse ? 1 : 0;
        this.camera = new OrthographicCamera(-1, 1, 1, -1, 0, 1);
        this.lines = new MaskLines();
        this.reposition();

        this.scene.add(this.lines);
        this.update();
    }

    reposition() {
        this.progressLength = getPhrasesInPercent().entering;
    }

    update(progress) {
        if (progress !== undefined) {
            this.progress = progress;
            this.progress = smoothstep(0, this.progressLength, progress);
            if (this._reverse) {
                this.progress = 1 - this.progress;
            }
        }
        this.lines.update(this.progress);
    }

    translate(x, y) {
        this.lines.position.x = x;
        this.lines.position.y = y;
    }

    destroy() {
        this.lines.destroy();

        this.scene.remove(this.lines);
    }

    set reverse(value) {
        if (value !== this._reverse) {
            this.progress = 1 - this.progress;
            this.update();
        }
        this._reverse = value;
    }
}
